import http from '../http';
import { useEffect,useState } from 'react';
import { Link,useNavigate } from 'react-router-dom';
import AuthUser from './AuthUser';

export default function Home(){
    const {getToken}=AuthUser();
    const navigate=useNavigate();
    const [users, setUsers] = useState([]);
    // useEffect(()=>{
    //     if(!getToken()){
    //         navigate('/login');
    //     } else {

    //         fetchAllUsers();
    //     }
    // },[navigate,getToken]);
    useEffect(()=>{
        if(!getToken()){
                    navigate('/login');
                } else {
        
                    fetchAllUsers();
                }
        
    },[]);


    const fetchAllUsers =  ()=>{
        http.get('/users').then(res=>{
            setUsers(res.data);
        })
    }

    const deleteUser = (id)=>{
        http.delete('/users/'+id).then(res=>{
            fetchAllUsers();
        })
    }
    return (
        <div>
            <h1>Users</h1>
            <table className='table'>
                <thead>
                    <tr>
                <th>S No</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Action</th>
                </tr>
                </thead>
                <tbody>
                    {users.map((user,index)=>(
                <tr key={user.id}>
                    <td>{++index}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.phone}</td>
                    <td>
                        <Link className='btn btn-info' to={{pathname:"/update/"+user.id}}>Edit</Link>
                        <button type='button' className='btn btn-danger' onClick={()=>{
                            deleteUser(user.id)}}>Delete</button>
                    </td>
                    </tr>
))}
                </tbody>
            </table>
        </div>
    )
}